import {JustificativaResumo} from '../types'
import {fmtDate, FEEDBACK} from '../ui'

interface Props {
    justificativas: JustificativaResumo[]
    loading: boolean
    onAbrir: (id: string) => void
    onVoltar: () => void
}

function statusChip(status: string): {label: string; color: string; bg: string} {
    switch (status) {
        case 'APTA': return {label: 'Apta', color: FEEDBACK.success, bg: FEEDBACK.successSoft}
        case 'COM_RISCO': return {label: 'Com risco', color: FEEDBACK.warning, bg: FEEDBACK.warningSoft}
        case 'ERRO': return {label: 'Erro', color: FEEDBACK.danger, bg: FEEDBACK.dangerSoft}
        case 'PROCESSANDO': return {label: 'Processando', color: FEEDBACK.info, bg: FEEDBACK.infoSoft}
        default: return {label: status, color: FEEDBACK.muted, bg: FEEDBACK.mutedSoft}
    }
}

export default function HistoricoView({justificativas, loading, onAbrir, onVoltar}: Props) {
    return (
        <div>
            <header className="page-header">
                <div className="crumb">
                    <a onClick={onVoltar}>Ata Inteligente</a>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                    <span>Minhas justificativas</span>
                </div>
                <div className="header-row">
                    <h1 className="lg-h2">Minhas justificativas</h1>
                    <button className="lg-btn lg-btn--secondary lg-btn--sm" onClick={onVoltar}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                        Nova busca
                    </button>
                </div>
                <p className="lg-text-muted" style={{marginBottom: 0}}>Justificativas de adesão geradas pela sua organização — abra para revisar e baixar de novo.</p>
            </header>

            <div className="page-content">
                <div style={{display: 'flex', flexDirection: 'column', gap: 14}}>
                    {loading && (
                        <div className="lg-empty"><div className="lg-empty__title">Carregando…</div></div>
                    )}

                    {!loading && justificativas.length === 0 && (
                        <div className="lg-empty">
                            <svg className="lg-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                            <div className="lg-empty__title">Nenhuma justificativa ainda</div>
                            <div className="lg-empty__description">Pesquise uma ata, avalie a adesão e gere a primeira justificativa.</div>
                        </div>
                    )}

                    {!loading && justificativas.map((j) => {
                        const st = statusChip(j.status)
                        return (
                            <div key={j.id} className="ata-card">
                                <div className="ata-card__top">
                                    <div>
                                        <div className="ata-card__objeto" style={{fontSize: 'var(--fs-base)'}}>{j.objeto || j.ata_numero_controle}</div>
                                        <div className="ata-card__org">
                                            <span style={{color: 'var(--text-tertiary)'}}>Ata {j.ata_numero_controle}</span>
                                            {j.criado_em && <span style={{color: 'var(--text-tertiary)'}}>· {fmtDate(j.criado_em.slice(0, 10))}</span>}
                                        </div>
                                    </div>
                                    <span className="selo" style={{color: st.color, background: st.bg}}>{st.label}</span>
                                </div>
                                <div className="ata-card__actions" style={{borderTop: '1px solid var(--border-subtle)', paddingTop: 12, marginTop: 4}}>
                                    <span />
                                    <button className="lg-btn lg-btn--brand lg-btn--sm" onClick={() => onAbrir(j.id)}>Abrir</button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
